import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@affinite/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthSearchComponent } from './auth-search.component';
import { A11yModule } from '@angular/cdk/a11y';
import { VdtDatepickerModule } from '@affinite/common';
import { PipesModule } from '@affinite/common';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    A11yModule,
    VdtDatepickerModule,
    PipesModule
  ],
  declarations: [
    AuthSearchComponent
  ],
  exports: [
    AuthSearchComponent
  ]
})
export class AuthSearchModule { }
